





























import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'IconUser',
  props: {
    width: {
      type: String,
      default: '17',
    },
    height: {
      type: String,
      default: '22',
    },
  },
});
